import { render, staticRenderFns } from "./PostMintingActions.vue?vue&type=template&id=7e077970&"
import script from "./PostMintingActions.vue?vue&type=script&lang=js&"
export * from "./PostMintingActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports